import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AddBeneficiaryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AddBeneficiaryError', ...args);
    }
}
export default AddBeneficiaryError;
